/* eslint-disable no-undef */
import { iManagePopUp } from "../components/UI/IManageAuthMobile";
const iManageauthdialog = (): string => {
  const basePath = window.location.pathname.split('/').slice(0, -1).join('/');
  return `${location.protocol}//${location.hostname}${location.port ? ":" + location.port : ""}${basePath}/iManageauthdialog.html`;
};

let loginDialog;

const fullUrl = iManageauthdialog();
export const iManageLoginModal = (iManageAuthUrl: string, hostName: string,  onClose: () => void) => {
  if (hostName === "OutlookAndroid") {
      iManagePopUp(iManageAuthUrl);
      onClose();
     } else {
          //use dialog
      Office.context.ui.displayDialogAsync(fullUrl, { height: 60, width: 30 }, (asyncResult) => {
        loginDialog = asyncResult.value;
        // wait for the dialog to tell us its ready to process messages. Once it is, we can sent messages to it
        loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
          if (arg.message === "Ready") {
            loginDialog.messageChild(iManageAuthUrl);
          }
          if (arg.message === "authSuccess") {
            loginDialog.close();
            onClose();
          }
        });
      });
     }
  }

